"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPositiveAndNegativeValue = exports.isNumberValid = exports.clearValue = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable no-else-return */

/**
 * @desc
 * Clear thousand value from all separators, depending on decimalSeparator.
 *
 * @param str
 * @param thousandSeparator
 * @param decimalSeparator
 */
var clearValue = function clearValue(str, thousandSeparator, decimalSeparator) {
  str = String(str);

  if (thousandSeparator) {
    // default value of the thousand separator, if only true is set, or the empty space is given
    var replaceWhat = ' ';

    if (typeof thousandSeparator !== 'boolean') {
      replaceWhat = thousandSeparator;

      if (thousandSeparator !== ' ') {
        if (decimalSeparator === ',') {
          replaceWhat = '.';
        } else if (decimalSeparator === '.') {
          replaceWhat = ',';
        }
      }
    }

    if (replaceWhat === '.') {
      str = str.split('.').join('');
    } else {
      var re = new RegExp(replaceWhat, 'g');
      str = str.replace(re, '');
    }
  }

  return str.replace(decimalSeparator, '.');
};
/**
 * @desc
 * Checks if the number is valid by the specific rules.
 *
 * @param value
 * @param size
 * @param positive
 */


exports.clearValue = clearValue;

var isNumberValid = function isNumberValid(_ref) {
  var floatValue = _ref.floatValue;
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var positive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var maxSize = Math.pow(10, size) - 1;

  if (!positive && floatValue > 0) {
    return false;
  }

  if (floatValue > maxSize) {
    return false;
  }

  return true;
};
/**
 * @desc
 * Changes the number to zero if the initial value is not fit to the condition.
 *
 * @param value
 * @param negative
 * @param positive
 * @param integer
 * @param decimalSeparator
 */


exports.isNumberValid = isNumberValid;

var formatPositiveAndNegativeValue = function formatPositiveAndNegativeValue(value, negative, positive, integer, decimalSeparator) {
  if (!negative && value < 0) {
    return 0;
  }

  if (!positive && value > 0) {
    return 0;
  }

  var str = (value === null || value === void 0 ? void 0 : value.toString()) || '';

  var _str$split = str.split(decimalSeparator),
      _str$split2 = _slicedToArray(_str$split, 2),
      intPart = _str$split2[0],
      decimalPart = _str$split2[1];

  var truncatedInt = intPart.slice(0, integer);
  var decimalEnd = decimalPart ? "".concat(decimalSeparator).concat(decimalPart) : '';
  var finalStr = "".concat(truncatedInt).concat(decimalEnd);
  return finalStr;
};

exports.formatPositiveAndNegativeValue = formatPositiveAndNegativeValue;
//# sourceMappingURL=utils.js.map